import { Levels } from '../../enums/pdf-tron/levels.enum';
import { RowTypes } from '../../enums/pdf-tron/row-types.enum';

export interface FixedAssetScheduleRowFormatted {
    rowType: RowTypes;
    t: string;
    g1oV: string;
    g1a: string;
    g1d: string;
    g1t: string;
    g1cV: string;
    g2oV: string;
    g2a: string;
    g2d: string;
    g2t: string;
    g2cV: string;
    aV: string;
    cV: string;
    pV: string;
    level: Levels;
    markedForRemoval: boolean;
    disableNumbering?: boolean;
    isGroup?: boolean;
}
